/**
 * True when the page is driven by the Cypress E2E suite.
 *
 * Cypress exposes itself on the application window, so this holds wherever
 * the suite runs (local, dev, stage) and is never set for a real visitor.
 * Per-session telemetry (Datadog RUM, Session Replay) is kept off such runs:
 * every automated session is billed, and in stage they outnumber manual
 * sessions roughly 30:1 (card 184369).
 */
export function isAutomatedBrowser(): boolean {
  return typeof window !== 'undefined' && window.Cypress !== undefined;
}
